import { customElement, property } from 'lit/decorators';

import { TextField } from '@material/mwc-textfield';
import { css } from 'lit';

@customElement('proxi-textfield')
export class ProxiTextfield extends TextField {

    @property({ type: String }) height: string = '2rem';

    @property({ type: Boolean }) outlined: boolean = true;

    static get styles() {
        return [
            ...TextField.styles,
            css`
                :host {
                    width: 100%;
                    padding: 5px 0;
                    --mdc-icon-size: 1rem;
                }

                .mdc-text-field {
                    height: var(--textfield-height, 2rem);
                    width: 100%;
                }

                .mdc-text-field__icon--leading {
                    margin-left: 8px;
                    margin-right: 4px;
                }

                .mdc-text-field-helper-line {
                    height: 0;
                }

                .mdc-floating-label {
                    transform: translateY(-50%) scale(0.75); /* Adjust the label position */
                }

                .mdc-text-field--outlined .mdc-floating-label {
                    transform: translateY(-1.5rem) scale(0.75); /* Adjust the label position for outlined variant */
                    background: white;
                }

                .mdc-text-field--outlined .mdc-floating-label--float-above {
                    transform: translateY(-1.5rem) scale(0.75); /* Adjust the label position when floating for outlined variant */
                }

                .mdc-notched-outline {
                    height: var(--textfield-height, 2rem);
                }

                .mdc-notched-outline__notch {
                    padding: 0;
                }

                /* Char counter inside */
                .mdc-text-field-character-counter {
                    font-size: 0.6rem;
                    position: relative;
                    right: 0;
                    margin-top: -20px;
                    margin-right: -10px;
                }

                .mdc-text-field + .mdc-text-field-helper-line {
                    padding-left: 0;
                }
            `
        ];
    }

    updated(changedProperties: Map<string | number | symbol, unknown>) {
        if (changedProperties.has('height')) {
            this.style.setProperty('--textfield-height', this.height);
        }
    }
}